import { atom } from "jotai";

import { EventSignUpProcessSteps } from "@whoosh/features/src/Events/features/AddorEditSignUp";

import { eventSignUpModalStatusAtom } from "../../stores/eventSignUpModal";

export const openEventSignUpModalAtom = atom(
  null,
  (get, set, payload?: { overrideStep?: EventSignUpProcessSteps | null }) => {
    set(eventSignUpModalStatusAtom, {
      isOpen: true,
      overrideStep: payload?.overrideStep ?? null,
    });
  }
);
